import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie-only auth: httpOnly `raf_session` cookie is set by backend and sent
// automatically by the browser. No token in localStorage/JS memory → immune to XSS.
export const api = axios.create({ baseURL: API, withCredentials: true });
